import { FC } from 'react';
import { Link } from 'react-router-dom'

import Card from '@components/elements/Card';
import { PlusIcon } from '@components/elements/Icons';
import CompanyProxyList from '@components/modules/Admin/Proxy/CompanyProxyList';
import PollProxyModule from '@components/modules/Admin/Proxy/PollProxyModule';

const AdminProxyPage: FC = () => {
  return (
    <div className="h-screen overflow-x-hidden overflow-y-scroll bg-fixed bg-blue-light">
      <div className="mx-4 mt-16">
        <h1 className="mb-4 text-4xl text-white whitespace-pre-line">
          {`Assign & Remove Proxy`}
        </h1>
        <p className="mt-4 text-sm text-white">
          Update the list of proxies for your Organization
        </p>
      </div>
      <div className="flex flex-col gap-4 mx-auto xl:gap-8 lg:flex-row">
        <div className="w-full lg:min-h-screen lg:sticky lg:top-0 lg:w-108">
          <div className="flex flex-col mx-4 my-4 space-y-2 lg:mr-0 lg:ml-4">
          <h2 className="text-white uppercase">COMPANY MEMBERS</h2>

            <Link to='/admin/members'>
              <div 
                role="button"
                className="flex p-4 text-black bg-yellow "
              >
                <PlusIcon className="mr-2" />
                Add new company member
              </div>
            </Link>
            <h2 className="text-white uppercase">COMPANY PROXIES</h2>
            <Card shadowColor="yellow" className="p-4 text-center">
              <CompanyProxyList />
            </Card>
          </div>
        </div>
        <div className="flex flex-1">
          <div className="flex-1 pb-24">
            <div className="flex flex-col mx-4 my-4 space-y-2 lg:mr-4 lg:ml-0">
              <PollProxyModule />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminProxyPage;
